import type { FaireProductEntity } from "../../entity_types/product";

export const p_8uadsp6rcu: FaireProductEntity = {
  token: "p_8uadsp6rcu",
  type: "product",
  name: "I'm Too Old For This Shit Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/aa0ec0974f00835bf3c2f16a069d4b8da9d6d1ee67286c94ccd1a0c774238c50.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b4d5ad091d9e84ecfe31d401d1763de61b74cc9839323c5b3611e1c058ceea18.jpeg",
    "https://cdn.faire.com/fastly/5683f6fba84f102694ae72fa10a821b1fdd99959ec6a42285adca0c44259be52.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/01704cb4b047540b9bfe8e4c97ec94c5e0d3c62be09392cba046a4aa79bfb587.jpeg",
    "https://cdn.faire.com/fastly/f86fb7a9cd43725e984fff84bc9881b277ee6adf5b131f5d133977fefdd0b13f.jpeg",
    "https://cdn.faire.com/fastly/4bd00817fa472a85df24cf434017a962d2be03649b06d8250fe61e0f409a2e54.jpeg"
  ],
  priceDollars: 6.75,
  description: "Doesn't matter if you're 8 or 80, there's some shit you're just too old for... and oldies deserve comfies... so get you some socks and cozy up!\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:31:00.122Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
